import React, { useEffect, lazy, Suspense, useState } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import Login from "./pages/login/login";
import { Toaster } from "react-hot-toast";
import Protectedroute from "./Maincomponent/Protectedroute";
import CustomerEnquiryform from "./pages/customerenquiry/customerEnquiry";
import "antd/dist/reset.css";
import AppLoadingSplash from "./component/AppLoadingSplash";
import "./index.css"
import FreeformQuotationBuilder from "./pages/quotationbuilder/QuotationBuilder";
import PipelineBoard from "./pages/pipeline/PipelineBoard";
import InvitationPage from "./pages/Addagent/InvitationPage";
import LeadSourcePanel from "./pages/console/leadsoucepanel/leadpanel";
import SubLeadSourcePanel from "./pages/console/SubLeadSourcePanel/SubLeadSourcePanel";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CustomFieldMasterPanel from "./pages/console/customfields/Customfieldmasterpanel";
import CustomFieldMaster from "./pages/console/customfields/Customfieldmasterpanel";
const MainLayout = lazy(() => import("./pages/layout/MainLayout"));
const DashboardPage = lazy(() => import("./pages/dashboardmain/DashboardPage"));
const LeadsPage = lazy(() => import("./pages/leads/LeadsPage"));
const UsagePage = lazy(() => import("./pages/usage/UsagePage"));
const DatewiseReportPage = lazy(() => import("./pages/report/DatewiseReportPage"));
const ProductPanelPage = lazy(() => import("./pages/productpanel/ProductPanelPage"));
const TodoPage = lazy(() => import("./pages/todo/TodoPage"));
const AgentPanelPage = lazy(() => import("./pages/Addagent/AgentPanelPage"));
const ConsolePage = lazy(() => import("./pages/console/ConsolePage"));
const StagePanelPage = lazy(() => import("./pages/console/StagePanelPage"));

const App = () => {
	useEffect(() => {
		console.error = () => {};
	}, []);
const [initializing, setInitializing] = useState(true);

	useEffect(() => {
	
		const init = async () => {
			
			setInitializing(false);
		};
		init();
	}, []);

	if (initializing) {
		return <AppLoadingSplash appName="TrackLeads" />;
	}

	return (
		<Router>
			<Routes>
<Route path="privacypolicy"  element={<PrivacyPolicy />} />
<Route path="termsofservices"  element={<TermsOfService />} />
				<Route path="/login" element={<Login />} />
				<Route path="/invitation" element={<InvitationPage />} />
				

				
				<Route
					path="/activeleads"
					element={<Navigate to="/leads/active" replace />}
				/>
				<Route
					path="/productpanel"
					element={<Navigate to="/products" replace />}
				/>

				<Route
					path="/"
					element={
						<Protectedroute>
							<Suspense fallback={<AppLoadingSplash appName="TrackLeads" />}>
								<MainLayout />
							</Suspense>
						</Protectedroute>
					}
				>
<Route path="/addlead" element={<CustomerEnquiryform to="/addlead" replace />} />
					<Route index element={<DashboardPage />} />
					<Route path="leads/:leadtype" element={<LeadsPage />} />
					<Route path="usage" element={<UsagePage />} />
					<Route path="datewise" element={<DatewiseReportPage />} />
					<Route path="products" element={<ProductPanelPage />} />
					<Route path="pipeline" element={<TodoPage />} />
					<Route path="agentpanel" element={<AgentPanelPage />} />
<Route path="custom-fields" element={<CustomFieldMaster />} />
					<Route path="console" element={<ConsolePage />} />
					<Route path="forgot" element={<ForgotPasswordPage/>} />
<Route path="lead-sources" element={<LeadSourcePanel />} />
<Route path="sub-lead-sources" element={<SubLeadSourcePanel />} />
					<Route path="stages" element={<StagePanelPage />} />
					<Route path="quotationdesigner" element={<FreeformQuotationBuilder />} />
					<Route path="pipelinenew" element={<PipelineBoard />} />
				</Route>
			</Routes>
			<Toaster />
		</Router>
	);
};

export default App;
